import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import classnames from "classnames";
import _ from "lodash";

import styles from "./HeaderBar.scss";
import ModalWrapper from "../../../../components/common/modalWrapper/ModalWrapper";

class HeaderBar extends React.Component {
  render() {
    const {
      center,
      color,
      flexDirection,
      title,
      text,
      buttons
    } = this.props.common.headerBar;

    const componentClassName = classnames({
      [styles.headerBar]: true,
      [styles.headerBarGrey]: color === "grey",
      [styles.headerBarGreen]: color === "green",
      [styles.center]: center,
      hidden: this.props.loading
    });

    const containerClassName = classnames({
      [styles.container]: true,
      [styles.containerColumn]: flexDirection === "column"
    });

    return (
      !_.isEmpty(this.props.common.headerBar) && (
        <div className={componentClassName}>
          <div className={containerClassName}>
            <div className={styles.flex2}>
              <div className={styles.title}>{title}</div>
              <div className={styles.text}>{text}</div>
            </div>
            {!_.isEmpty(buttons) && (
              <div className={styles.flex}>{this.renderButtons()}</div>
            )}
          </div>
        </div>
      )
    );
  }

  renderButtons() {
    const buttons = this.props.common.headerBar.buttons;

    if (!_.isEmpty(buttons)) {
      const mappedButtons = buttons.map((button, index) => {
        const componentClassName = classnames({
          [styles.button]: true,
          [styles.buttonDisabled]: button.disabled,
          [styles.buttonBlue]: button.color === "blue",
          [styles.buttonGrey]: button.color === "grey",
          [styles.buttonGreen]: button.color === "green"
        });

        const props = {
          className: componentClassName,
          disabled: button.disabled,
          children: button.text,
          onClick: button.onClick,
          key: index
        };

        if (button.type === "link") {
          return <Link {...props} to={button.to} key={index} />;
        } else if (button.type === "modalTrigger") {
          return (
            <ModalWrapper
              Modal={button.modal}
              modalClick={button.modalClick}
              modalProps={button.modalProps}
              key={index}
            >
              <button {...props} />
            </ModalWrapper>
          );
        } else {
          return <button {...props} key={index} />;
        }
      });

      return <div className={styles.actions}>{mappedButtons}</div>;
    }
  }
}

const mapStateToProps = state => {
  return {
    common: state.common
  };
};

export default connect(mapStateToProps)(HeaderBar);



// WEBPACK FOOTER //
// ./src/routes/common/header/headerBar/HeaderBar.js